export const MY_FORM_FIELD_IMAGE = 'image';
export const MY_FORM_FIELD_IMAGE_MULTIPLE = 'image-multiple';
export const MY_FORM_FIELD_TEXT = 'text';
export const MY_FORM_FIELD_HTML = 'html';
export const MY_FORM_FIELD_DATE = 'date';
export const MY_FORM_FIELD_TIME = 'time';
export const MY_FORM_FIELD_SELECT = 'select';
export const MY_FORM_FIELD_SELECT_MULTIPLE = 'select-multiple';
export const MY_FORM_FIELD_SELECT_AUTOCOMPLETE = 'select-autocomplete';
export const MY_FORM_FIELD_COORDINATE = 'coordinate';
export const MY_FORM_FIELD_CHECKBOX = 'checkbox';

export const MY_FORM_FIELDS = [
  MY_FORM_FIELD_IMAGE,
  MY_FORM_FIELD_IMAGE_MULTIPLE,
  MY_FORM_FIELD_TEXT,
  MY_FORM_FIELD_HTML,
  MY_FORM_FIELD_DATE,
  MY_FORM_FIELD_TIME,
  MY_FORM_FIELD_SELECT,
  MY_FORM_FIELD_SELECT_MULTIPLE,
  MY_FORM_FIELD_SELECT_AUTOCOMPLETE,
  MY_FORM_FIELD_COORDINATE,
  MY_FORM_FIELD_CHECKBOX,
];
